import { Controller, useFormContext } from "react-hook-form";
import { IQuestionForm, SubquestionForm } from "../../../../QuestionForm/QuestionForm";
import { useMst } from "../../../../../mobx";
import React, { useState } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { parse } from "query-string";
import { QuestionQuery } from "../../../../../api/questions/typings";

export default observer(function () {
	const { control } = useFormContext<IQuestionForm | SubquestionForm>();
	const { topicsStore } = useMst();
	const { getTopics, getTopicsData } = topicsStore;
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const params = parse(location.search) as QuestionQuery;
	const defaultTopics = Array.isArray(params["filter[topics][]"])
		? params["filter[topics][]"]
		: params["filter[topics][]"]
		? [params["filter[topics][]"]]
		: [];

	const onOpen = async () => {
		setLoading(true);
		await getTopics();
		setLoading(false);
	};

	return (
		<Controller
			control={control}
			name={"topics"}
			defaultValue={defaultTopics.map((id) => getTopicsData.find((x) => x.id === id)).filter((x) => !!x)}
			render={({ field: { value, onChange } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					onOpen={onOpen}
					loading={loading}
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Темы"}
							placeholder={"Выберите тему"}
						/>
					)}
					getOptionLabel={(option) => option.title}
					renderTags={(values, getTagProps) =>
						values.map((value, i) => (
							<Chip
								color={"primary"}
								size={"small"}
								variant={"outlined"}
								label={value.title}
								{...getTagProps({ index: i })}
							/>
						))
					}
					renderOption={(props, option) => (
						<li {...props} key={option.title + option.id}>
							{option.title}
						</li>
					)}
					options={getTopicsData}
				/>
			)}
		/>
	);
});
